const Datenschutz = () => {
    return (
        <div className='pt-24 md:w-160 m-0 m-auto px-9'>
            <article>
                <header>
                    <h1 className='text-3xl mb-20 font-Atma'>
                        Datenschutzerklärung
                    </h1>
                </header>
                <section>
                    <h2 className='text-2xl mb-4 font-bold'>
                        Einleitung und Überblick
                    </h2>
                    <p className='mb-16'>
                        Wir haben diese Datenschutzerklärung (Fassung
                        12.10.2022-312225268) verfasst, um Ihnen gemäß der
                        Vorgaben der Datenschutz-Grundverordnung (EU) 2016/679
                        und anwendbaren nationalen Gesetzen zu erklären, welche
                        personenbezogenen Daten (kurz Daten) wir als
                        Verantwortliche – und die von uns beauftragten
                        Auftragsverarbeiter (z. B. Provider) – verarbeiten,
                        zukünftig verarbeiten werden und welche rechtmäßigen
                        Möglichkeiten Sie haben. Die verwendeten Begriffe sind
                        geschlechtsneutral zu verstehen. Kurz gesagt: Wir
                        informieren Sie umfassend über Daten, die wir über Sie
                        verarbeiten. Datenschutzerklärungen klingen für
                        gewöhnlich sehr technisch und verwenden juristische
                        Fachbegriffe. Diese Datenschutzerklärung soll Ihnen
                        hingegen die wichtigsten Dinge so einfach und
                        transparent wie möglich beschreiben. Soweit es der
                        Transparenz förderlich ist, werden technische Begriffe
                        leserfreundlich erklärt, Links zu weiterführenden
                        Informationen geboten und Grafiken zum Einsatz gebracht.
                        Wir informieren damit in klarer und einfacher Sprache,
                        dass wir im Rahmen unserer Geschäftstätigkeiten nur dann
                        personenbezogene Daten verarbeiten, wenn eine
                        entsprechende gesetzliche Grundlage gegeben ist. Das ist
                        sicher nicht möglich, wenn man möglichst knappe, unklare
                        und juristisch-technische Erklärungen abgibt, so wie sie
                        im Internet oft Standard sind, wenn es um Datenschutz
                        geht. Ich hoffe, Sie finden die folgenden Erläuterungen
                        interessant und informativ und vielleicht ist die eine
                        oder andere Information dabei, die Sie noch nicht
                        kannten. Wenn trotzdem Fragen bleiben, möchten wir Sie
                        bitten, sich an die unten bzw. im Impressum genannte
                        verantwortliche Stelle zu wenden, den vorhandenen Links
                        zu folgen und sich weitere Informationen auf Drittseiten
                        anzusehen. Unsere Kontaktdaten finden Sie
                        selbstverständlich auch im Impressum.
                    </p>
                </section>
                <section>
                    <h2 className='text-2xl mb-4 font-bold'>
                        Anwendungsbereich
                    </h2>
                    <p className='mb-8'>
                        Diese Datenschutzerklärung gilt für alle von uns im
                        Unternehmen verarbeiteten personenbezogenen Daten und
                        für alle personenbezogenen Daten, die von uns
                        beauftragte Firmen (Auftragsverarbeiter) verarbeiten.
                        Mit personenbezogenen Daten meinen wir Informationen im
                        Sinne des Art. 4 Nr. 1 DSGVO wie zum Beispiel Name,
                        E-Mail-Adresse und postalische Anschrift einer Person.
                        Die Verarbeitung personenbezogener Daten sorgt dafür,
                        dass wir unsere Dienstleistungen und Produkte anbieten
                        und abrechnen können, sei es online oder offline. Der
                        Anwendungsbereich dieser Datenschutzerklärung umfasst:
                    </p>
                    <ul className='list-disc ml-6'>
                        <li>
                            alle Onlineauftritte (Websites, Onlineshops), die
                            wir betreiben
                        </li>
                        <li>Social Media Auftritte und E-Mail-Kommunikation</li>
                        <li>mobile Apps für Smartphones und andere Geräte</li>
                    </ul>

                    <p className='mb-16 pt-8'>
                        Kurz gesagt: Die Datenschutzerklärung gilt für alle
                        Bereiche, in denen personenbezogene Daten im Unternehmen
                        über die genannten Kanäle strukturiert verarbeitet
                        werden. Sollten wir außerhalb dieser Kanäle mit Ihnen in
                        Rechtsbeziehungen eintreten, werden wir Sie
                        gegebenenfalls gesondert informieren.
                    </p>
                </section>
                <section>
                    <h2 className='text-2xl mb-4 font-bold'>
                        Rechtsgrundlagen
                    </h2>
                    <p>
                        In der folgenden Datenschutzerklärung geben wir Ihnen
                        transparente Informationen zu den rechtlichen
                        Grundsätzen und Vorschriften, also den Rechtsgrundlagen
                        der Datenschutz-Grundverordnung, die uns ermöglichen,
                        personenbezogene Daten zu verarbeiten. Was das EU-Recht
                        betrifft, beziehen wir uns auf die VERORDNUNG (EU)
                        2016/679 DES EUROPÄISCHEN PARLAMENTS UND DES RATES vom
                        27. April 2016. Diese Datenschutz-Grundverordnung der EU
                        können Sie selbstverständlich online auf EUR-Lex, dem
                        Zugang zum EU-Recht, unter{' '}
                        <a href='url'>
                            https://eur-lex.europa.eu/legal-content/DE/ALL/?uri=celex%3A32016R0679{' '}
                        </a>{' '}
                        nachlesen.
                    </p>
                    <p className='mt-8 mb-8'>
                        Wir verarbeiten Ihre Daten nur, wenn mindestens eine der
                        folgenden Bedingungen zutrifft:
                    </p>
                    <ol className='list-decimal ml-6 mb-8'>
                        <li>
                            Einwilligung (Artikel 6 Absatz 1 lit. a DSGVO): Sie
                            haben uns Ihre Einwilligung gegeben, Daten zu einem
                            bestimmten Zweck zu verarbeiten. Ein Beispiel wäre
                            die Speicherung Ihrer eingegebenen Daten eines
                            Kontaktformulars.
                        </li>
                        <li>
                            Vertrag (Artikel 6 Absatz 1 lit. b DSGVO): Um einen
                            Vertrag oder vorvertragliche Verpflichtungen mit
                            Ihnen zu erfüllen, verarbeiten wir Ihre Daten. Wenn
                            wir zum Beispiel einen Kaufvertrag mit Ihnen
                            abschließen, benötigen wir vorab personenbezogene
                            Informationen.
                        </li>
                        <li>
                            Rechtliche Verpflichtung (Artikel 6 Absatz 1 lit. c
                            DSGVO): Wenn wir einer rechtlichen Verpflichtung
                            unterliegen, verarbeiten wir Ihre Daten. Zum
                            Beispiel sind wir gesetzlich verpflichtet Rechnungen
                            für die Buchhaltung aufzuheben. Diese enthalten in
                            der Regel personenbezogene Daten.
                        </li>
                        <li>
                            Berechtigte Interessen (Artikel 6 Absatz 1 lit. f
                            DSGVO): Im Falle berechtigter Interessen, die Ihre
                            Grundrechte nicht einschränken, behalten wir uns die
                            Verarbeitung personenbezogener Daten vor. Wir müssen
                            zum Beispiel gewisse Daten verarbeiten, um unsere
                            Website sicher und wirtschaftlich effizient
                            betreiben zu können. Diese Verarbeitung ist somit
                            ein berechtigtes Interesse.
                        </li>
                    </ol>
                    <p className='mb-8'>
                        Weitere Bedingungen wie die Wahrnehmung von Aufnahmen im
                        öffentlichen Interesse und Ausübung öffentlicher Gewalt
                        sowie dem Schutz lebenswichtiger Interessen treten bei
                        uns in der Regel nicht auf. Soweit eine solche
                        Rechtsgrundlage doch einschlägig sein sollte, wird diese
                        an der entsprechenden Stelle ausgewiesen.
                    </p>
                    <p className='mb-6'>
                        Zusätzlich zu der EU-Verordnung gelten auch noch
                        nationale Gesetze:
                    </p>
                    <ul className='list-disc ml-6 mb-6'>
                        <li>
                            In Österreich ist dies das Bundesgesetz zum Schutz
                            natürlicher Personen bei der Verarbeitung
                            personenbezogener Daten (Datenschutzgesetz), kurz
                            DSG.
                        </li>
                        <li>
                            In Deutschland gilt das Bundesdatenschutzgesetz,
                            kurz BDSG.
                        </li>
                    </ul>
                    <p>
                        Sofern weitere regionale oder nationale Gesetze zur
                        Anwendung kommen, informieren wir Sie in den folgenden
                        Abschnitten darüber.
                    </p>
                </section>
                <section>
                    <h2 className='text-2xl mb-4 mt-8 font-bold'>
                        Kontaktdaten des Verantwortlichen
                    </h2>
                    <p className='mb-6'>
                        Sollten Sie Fragen zum Datenschutz oder zur Verarbeitung
                        personenbezogener Daten haben, finden Sie nachfolgend
                        die Kontaktdaten der verantwortlichen Person bzw.
                        Stelle:
                    </p>
                    <div className='ml-6'>
                        <adress>
                            MD Bauernhof
                            <br />
                            Margot Döpper
                            <br />
                            Zur Linde 38ß41, 51515 Kürten, Deutschland
                            <br />
                            E-Mail: mdbauernhof@aol.com
                            <br />
                            Telefon: +49 022074146
                            <br />
                            Impressum: https://www.mdbauernhof.de/#/impressum
                            <br />
                        </adress>
                    </div>
                </section>
                <section>
                    <h2 className='text-2xl mb-4 mt-8 font-bold'>
                        Speicherdauer
                    </h2>
                    <p>
                        Dass wir personenbezogene Daten nur so lange speichern,
                        wie es für die Bereitstellung unserer Dienstleistungen
                        und Produkte unbedingt notwendig ist, gilt als
                        generelles Kriterium bei uns. Das bedeutet, dass wir
                        personenbezogene Daten löschen, sobald der Grund für die
                        Datenverarbeitung nicht mehr vorhanden ist. In einigen
                        Fällen sind wir gesetzlich dazu verpflichtet, bestimmte
                        Daten auch nach Wegfall des ursprüngliches Zwecks zu
                        speichern, zum Beispiel zu Zwecken der Buchführung.
                        Sollten Sie die Löschung Ihrer Daten wünschen oder die
                        Einwilligung zur Datenverarbeitung widerrufen, werden
                        die Daten so rasch wie möglich und soweit keine Pflicht
                        zur Speicherung besteht, gelöscht. Über die konkrete
                        Dauer der jeweiligen Datenverarbeitung informieren wir
                        Sie weiter unten, sofern wir weitere Informationen dazu
                        haben.
                    </p>
                </section>
                <section>
                    <h2 className='text-2xl mb-4 mt-8 font-bold'>
                        Rechte laut Datenschutz-Grundverordnung
                    </h2>
                    <p>
                        Gemäß Artikel 13, 14 DSGVO informieren wir Sie über die
                        folgenden Rechte, die Ihnen zustehen, damit es zu einer
                        fairen und transparenten Verarbeitung von Daten kommt:
                    </p>
                    <ul className='list-disc ml-6 mb-6'>
                        <li className='mt-6'>
                            Sie haben laut Artikel 15 DSGVO ein Auskunftsrecht
                            darüber, ob wir Daten von Ihnen verarbeiten. Sollte
                            das zutreffen, haben Sie Recht darauf eine Kopie der
                            Daten zu erhalten und die folgenden Informationen zu
                            erfahren:
                            <ul className='list-disc ml-8 mt-4'>
                                <li>
                                    zu welchem Zweck wir die Verarbeitung
                                    durchführen;
                                </li>
                                <li>
                                    die Kategorien, also die Arten von Daten,
                                    die verarbeitet werden;
                                </li>
                                <li>
                                    wer diese Daten erhält und wenn die Daten an
                                    Drittländer übermittelt werden, wie die
                                    Sicherheit garantiert werden kann;
                                </li>
                                <li>wie lange die Daten gespeichert werden;</li>
                                <li>
                                    das Bestehen des Rechts auf Berichtigung,
                                    Löschung oder Einschränkung der Verarbeitung
                                    und dem Widerspruchsrecht gegen die
                                    Verarbeitung;
                                </li>
                                <li>
                                    dass Sie sich bei einer Aufsichtsbehörde
                                    beschweren können (Links zu diesen Behörden
                                    finden Sie weiter unten);
                                </li>
                                <li>
                                    die Herkunft der Daten, wenn wir sie nicht
                                    bei Ihnen erhoben haben;
                                </li>
                                <li>
                                    ob Profiling durchgeführt wird, ob also
                                    Daten automatisch ausgewertet werden, um zu
                                    einem persönlichen Profil von Ihnen zu
                                    gelangen.
                                </li>
                            </ul>
                            <li className='pt-4'>
                                Sie haben laut Artikel 16 DSGVO ein Recht auf
                                Berichtigung der Daten, was bedeutet, dass wir
                                Daten richtig stellen müssen, falls Sie Fehler
                                finden.
                            </li>
                            <li>
                                Sie haben laut Artikel 17 DSGVO das Recht auf
                                Löschung („Recht auf Vergessenwerden“), was
                                konkret bedeutet, dass Sie die Löschung Ihrer
                                Daten verlangen dürfen.
                            </li>
                            <li>
                                Sie haben laut Artikel 18 DSGVO das Recht auf
                                Einschränkung der Verarbeitung, was bedeutet,
                                dass wir die Daten nur mehr speichern dürfen
                                aber nicht weiter verwenden.
                            </li>
                            <li>
                                Sie haben laut Artikel 20 DSGVO das Recht auf
                                Datenübertragbarkeit, was bedeutet, dass wir
                                Ihnen auf Anfrage Ihre Daten in einem gängigen
                                Format zur Verfügung stellen.
                            </li>
                            <li>
                                Sie haben laut Artikel 21 DSGVO ein
                                Widerspruchsrecht, welches nach Durchsetzung
                                eine Änderung der Verarbeitung mit sich bringt.
                                <ul className='list-disc ml-8 mt-4'>
                                    <li>
                                        Wenn die Verarbeitung Ihrer Daten auf
                                        Artikel 6 Abs. 1 lit. e (öffentliches
                                        Interesse, Ausübung öffentlicher Gewalt)
                                        oder Artikel 6 Abs. 1 lit. f
                                        (berechtigtes Interesse) basiert, können
                                        Sie gegen die Verarbeitung Widerspruch
                                        einlegen. Wir prüfen danach so rasch wie
                                        möglich, ob wir diesem Widerspruch
                                        rechtlich nachkommen können.
                                    </li>
                                    <li>
                                        Werden Daten verwendet, um Direktwerbung
                                        zu betreiben, können Sie jederzeit gegen
                                        diese Art der Datenverarbeitung
                                        widersprechen. Wir dürfen Ihre Daten
                                        danach nicht mehr für Direktmarketing
                                        verwenden.
                                    </li>
                                    <li>
                                        Werden Daten verwendet, um Profiling zu
                                        betreiben, können Sie jederzeit gegen
                                        diese Art der Datenverarbeitung
                                        widersprechen. Wir dürfen Ihre Daten
                                        danach nicht mehr für Profiling
                                        verwenden.
                                    </li>
                                </ul>
                                <li className='mt-4'>
                                    Sie haben laut Artikel 22 DSGVO unter
                                    Umständen das Recht, nicht einer
                                    ausschließlich auf einer automatisierten
                                    Verarbeitung (zum Beispiel Profiling)
                                    beruhenden Entscheidung unterworfen zu
                                    werden.
                                </li>
                                <li>
                                    Sie haben laut Artikel 77 DSGVO das Recht
                                    auf Beschwerde. Das heißt, Sie können sich
                                    jederzeit bei der Datenschutzbehörde
                                    beschweren, wenn Sie der Meinung sind, dass
                                    die Datenverarbeitung von personenbezogenen
                                    Daten gegen die DSGVO verstößt.
                                </li>
                            </li>
                        </li>
                    </ul>
                    <p className='mb-6'>
                        Kurz gesagt: Sie haben Rechte – zögern Sie nicht, die
                        oben gelistete verantwortliche Stelle bei uns zu
                        kontaktieren!
                    </p>
                    <p>
                        Wenn Sie glauben, dass die Verarbeitung Ihrer Daten
                        gegen das Datenschutzrecht verstößt oder Ihre
                        datenschutzrechtlichen Ansprüche in sonst einer Weise
                        verletzt worden sind, können Sie sich bei der
                        Aufsichtsbehörde beschweren. Diese ist für Österreich
                        die Datenschutzbehörde, deren Website Sie unter
                        https://www.dsb.gv.at/ finden. In Deutschland gibt es
                        für jedes Bundesland einen Datenschutzbeauftragten. Für
                        nähere Informationen können Sie sich an die
                        Bundesbeauftragte für den Datenschutz und die
                        Informationsfreiheit (BfDI) wenden. Für unser
                        Unternehmen ist die folgende lokale Datenschutzbehörde
                        zuständig:
                    </p>
                </section>
                <section>
                    <h2 className='text-2xl mb-4 mt-8 font-bold'>
                        Nordrhein-Westfalen Datenschutzbehörde{' '}
                    </h2>
                    <div className='ml-6'>
                        <adress>
                            Landesbeauftragte für Datenschutz: Bettina Gayk
                            <br />
                            Adresse: Kavalleriestraße 2-4, 40213 Düsseldorf
                            <br />
                            Telefonnr.: 02 11/384 24-0
                            <br />
                            E-Mail-Adresse: poststelle@ldi.nrw.de
                            <br />
                            Website: https://www.ldi.nrw.de/
                            <br />
                        </adress>
                    </div>
                </section>
                <section>
                    <h2 className='text-2xl mb-4 mt-8 font-bold'>
                        Sicherheit der Datenverarbeitung{' '}
                    </h2>
                    <p className='mb-6'>
                        Um personenbezogene Daten zu schützen, haben wir sowohl
                        technische als auch organisatorische Maßnahmen
                        umgesetzt. Wo es uns möglich ist, verschlüsseln oder
                        pseudonymisieren wir personenbezogene Daten. Dadurch
                        machen wir es im Rahmen unserer Möglichkeiten so schwer
                        wie möglich, dass Dritte aus unseren Daten auf
                        persönliche Informationen schließen können.
                    </p>
                    <p>
                        Art. 25 DSGVO spricht hier von “Datenschutz durch
                        Technikgestaltung und durch datenschutzfreundliche
                        Voreinstellungen” und meint damit, dass man sowohl bei
                        Software (z. B. Formularen) also auch Hardware (z. B.
                        Zugang zum Serverraum) immer an Sicherheit denkt und
                        entsprechende Maßnahmen setzt. Im Folgenden gehen wir,
                        falls erforderlich, noch auf konkrete Maßnahmen ein.
                    </p>
                </section>
                <section>
                    <h2 className='text-2xl mb-4 mt-8 font-bold'>
                        Kommunikation
                    </h2>
                    <div className='ml-6 mb-6'>
                        Kommunikation Zusammenfassung <br />
                        👥 Betroffene: Alle, die mit uns per Telefon, E-Mail
                        oder Online-Formular kommunizieren
                        <br />
                        📓 Verarbeitete Daten: z. B. Telefonnummer, Name,
                        E-Mail-Adresse, eingegebene Formulardaten. Mehr Details
                        dazu finden Sie bei der jeweils eingesetzten Kontaktart
                        <br />
                        🤝 Zweck: Abwicklung der Kommunikation mit Kunden,
                        Geschäftspartnern usw.
                        <br />
                        📅 Speicherdauer: Dauer des Geschäftsfalls und der
                        gesetzlichen Vorschriften
                        <br />
                        ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO
                        (Einwilligung), Art. 6 Abs. 1 lit. b DSGVO (Vertrag),
                        Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                        <br />
                    </div>
                    <p className='mb-6'>
                        Wenn Sie mit uns Kontakt aufnehmen und per Telefon,
                        E-Mail oder Online-Formular kommunizieren, kann es zur
                        Verarbeitung personenbezogener Daten kommen.
                    </p>
                    <p>
                        Die Daten werden für die Abwicklung und Bearbeitung
                        Ihrer Frage und des damit zusammenhängenden
                        Geschäftsvorgangs verarbeitet. Die Daten während eben
                        solange gespeichert bzw. solange es das Gesetz
                        vorschreibt.
                    </p>
                </section>
                <section>
                    <h2 className='text-2xl mb-4 mt-8 font-bold'>
                        Betroffene Personen
                    </h2>
                    <p>
                        Von den genannten Vorgängen sind alle betroffen, die
                        über die von uns bereit gestellten Kommunikationswege
                        den Kontakt zu uns suchen.
                    </p>
                </section>
                <section>
                    <h2 className='text-2xl mb-4 mt-8 font-bold'>Telefon</h2>
                    <p>
                        Wenn Sie uns anrufen, werden die Anrufdaten auf dem
                        jeweiligen Endgerät und beim eingesetzten
                        Telekommunikationsanbieter pseudonymisiert gespeichert.
                        Außerdem können Daten wie Name und Telefonnummer im
                        Anschluss per E-Mail versendet und zur
                        Anfragebeantwortung gespeichert werden. Die Daten werden
                        gelöscht, sobald der Geschäftsfall beendet wurde und es
                        gesetzliche Vorgaben erlauben.
                    </p>
                </section>
                <section>
                    <h2 className='text-2xl mb-4 mt-8 font-bold'>E-Mail</h2>
                    <p>
                        Wenn Sie mit uns per E-Mail kommunizieren, werden Daten
                        gegebenenfalls auf dem jeweiligen Endgerät (Computer,
                        Laptop, Smartphone,…) gespeichert und es kommt zur
                        Speicherung von Daten auf dem E-Mail-Server. Die Daten
                        werden gelöscht, sobald der Geschäftsfall beendet wurde
                        und es gesetzliche Vorgaben erlauben.
                    </p>
                </section>
                <section>
                    <h2 className='text-2xl mb-4 mt-8 font-bold'>
                        Online Formulare
                    </h2>
                    <p>
                        Wenn Sie mit uns mittels Online-Formular kommunizieren,
                        werden Daten auf unserem Webserver gespeichert und
                        gegebenenfalls an eine E-Mail-Adresse von uns
                        weitergeleitet. Die Daten werden gelöscht, sobald der
                        Geschäftsfall beendet wurde und es gesetzliche Vorgaben
                        erlauben.
                    </p>
                </section>
                <section>
                    <h2 className='text-2xl mb-4 mt-8 font-bold'>
                        Rechtsgrundlagen
                    </h2>
                    <p>
                        Die Verarbeitung der Daten basiert auf den folgenden
                        Rechtsgrundlagen:
                    </p>
                    <ul className='list-disc ml-8 mt-4'>
                        <li>
                            Art. 6 Abs. 1 lit. a DSGVO (Einwilligung): Sie geben
                            uns die Einwilligung Ihre Daten zu speichern und
                            weiter für den Geschäftsfall betreffende Zwecke zu
                            verwenden;
                        </li>
                        <li>
                            Art. 6 Abs. 1 lit. b DSGVO (Vertrag): Es besteht die
                            Notwendigkeit für die Erfüllung eines Vertrags mit
                            Ihnen oder einem Auftragsverarbeiter wie z. B. dem
                            Telefonanbieter oder wir müssen die Daten für
                            vorvertragliche Tätigkeiten, wie z. B. die
                            Vorbereitung eines Angebots, verarbeiten;
                        </li>
                        <li>
                            Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen):
                            Wir wollen Kundenanfragen und geschäftliche
                            Kommunikation in einem professionellen Rahmen
                            betreiben. Dazu sind gewisse technische
                            Einrichtungen wie z. B. E-Mail-Programme,
                            Exchange-Server und Mobilfunkbetreiber notwendig, um
                            die Kommunikation effizient betreiben zu können.
                        </li>
                    </ul>
                </section>
                <section>
                    <h2 className='text-2xl mb-4 mt-8 font-bold'>
                        Webhosting Einleitung
                    </h2>
                    <div className='ml-6 mb-6'>
                        Webhosting Zusammenfassung
                        <br />
                        👥 Betroffene: Besucher der Website
                        <br />
                        🤝 Zweck: professionelles Hosting der Website und
                        Absicherung des Betriebs
                        <br />
                        📓 Verarbeitete Daten: IP-Adresse, Zeitpunkt des
                        Websitebesuchs, verwendeter Browser und weitere Daten.
                        Mehr Details dazu finden Sie weiter unten bzw. beim
                        jeweils eingesetzten Webhosting Provider.
                        <br />
                        📅 Speicherdauer: abhängig vom jeweiligen Provider, aber
                        in der Regel 2 Wochen
                        <br />
                        ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit.f DSGVO
                        (Berechtigte Interessen)
                        <br />
                    </div>
                </section>
                <section>
                    <h2 className='text-2xl mb-4 mt-8 font-bold'>
                        Was ist Webhosting?
                    </h2>
                    <p className='mb-6'>
                        Wenn Sie heutzutage Websites besuchen, werden gewisse
                        Informationen – auch personenbezogene Daten –
                        automatisch erstellt und gespeichert, so auch auf dieser
                        Website. Diese Daten sollten möglichst sparsam und nur
                        mit Begründung verarbeitet werden. Mit Website meinen
                        wir übrigens die Gesamtheit aller Webseiten auf einer
                        Domain, d.h. alles von der Startseite (Homepage) bis hin
                        zur aller letzten Unterseite (wie dieser hier). Mit
                        Domain meinen wir zum Beispiel beispiel.de oder
                        musterbeispiel.com.
                    </p>
                    <p className='mb-6'>
                        Wenn Sie eine Website auf einem Computer, Tablet oder
                        Smartphone ansehen möchten, verwenden Sie dafür ein
                        Programm, das sich Webbrowser nennt. Sie kennen
                        vermutlich einige Webbrowser beim Namen: Google Chrome,
                        Microsoft Edge, Mozilla Firefox und Apple Safari. Wir
                        sagen kurz Browser oder Webbrowser dazu.
                    </p>
                    <p className='mb-6'>
                        Um die Website anzuzeigen, muss sich der Browser zu
                        einem anderen Computer verbinden, wo der Code der
                        Website gespeichert ist: dem Webserver. Der Betrieb
                        eines Webservers ist eine komplizierte und aufwendige
                        Aufgabe, weswegen dies in der Regel von professionellen
                        Anbietern, den Providern, übernommen wird. Diese bieten
                        Webhosting an und sorgen damit für eine verlässliche und
                        fehlerfreie Speicherung der Daten von Websites. Eine
                        ganze Menge Fachbegriffe, aber bitte bleiben Sie dran,
                        es wird noch besser!
                    </p>
                    <p className='mb-6'>
                        Bei der Verbindungsaufnahme des Browsers auf Ihrem
                        Computer (Desktop, Laptop, Tablet oder Smartphone) und
                        während der Datenübertragung zu und vom Webserver kann
                        es zu einer Verarbeitung personenbezogener Daten kommen.
                        Einerseits speichert Ihr Computer Daten, andererseits
                        muss auch der Webserver Daten eine Zeit lang speichern,
                        um einen ordentlichen Betrieb zu gewährleisten.
                    </p>
                    <p className='mb-6'>
                        Ein Bild sagt mehr als tausend Worte, daher zeigt
                        folgende Grafik zur Veranschaulichung das Zusammenspiel
                        zwischen Browser, dem Internet und dem Hosting-Provider.
                    </p>
                </section>
                <section>
                    <h2 className='text-2xl mb-4 mt-8 font-bold'>
                        Warum verarbeiten wir personenbezogene Daten?
                    </h2>
                    <p className='mb-6'>
                        Die Zwecke der Datenverarbeitung sind:
                    </p>
                    <ol className='list-decimal ml-6 mb-8'>
                        <li>
                            Professionelles Hosting der Website und Absicherung
                            des Betriebs
                        </li>
                        <li>
                            zur Aufrechterhaltung der Betriebs- und
                            IT-Sicherheit
                        </li>
                        <li>
                            Anonyme Auswertung des Zugriffsverhaltens zur
                            Verbesserung unseres Angebots und ggf. zur
                            Strafverfolgung bzw. Verfolgung von Ansprüchen
                        </li>
                    </ol>
                </section>
                <section>
                    <h2 className='text-2xl mb-4 mt-8 font-bold'>
                        Welche Daten werden verarbeitet?
                    </h2>
                    <p className='mb-6'>
                        Auch während Sie unsere Website jetzt gerade besuchen,
                        speichert unser Webserver, das ist der Computer auf dem
                        diese Webseite gespeichert ist, in der Regel automatisch
                        Daten wie
                    </p>
                    <ul className='list-disc ml-8 mt-4'>
                        <li>
                            die komplette Internetadresse (URL) der aufgerufenen
                            Webseite
                        </li>
                        <li>Browser und Browserversion (z. B. Chrome 87)</li>
                        <li>
                            das verwendete Betriebssystem (z. B. Windows 10)
                        </li>
                        <li>
                            die Adresse (URL) der zuvor besuchten Seite
                            (Referrer URL) (z. B.
                            https://www.beispielquellsite.de/vondabinichgekommen/)
                        </li>
                        <li>
                            den Hostnamen und die IP-Adresse des Geräts von
                            welchem aus zugegriffen wird (z. B. COMPUTERNAME und
                            194.23.43.121)
                        </li>
                        <li>Datum und Uhrzeit</li>
                        <li>in Dateien, den sogenannten Webserver-Logfiles</li>
                    </ul>
                </section>
                <section>
                    <h2 className='text-2xl mb-4 mt-8 font-bold'>
                        Wie lange werden Daten gespeichert?
                    </h2>
                    <p className='mb-6'>
                        In der Regel werden die oben genannten Daten zwei Wochen
                        gespeichert und danach automatisch gelöscht. Wir geben
                        diese Daten nicht weiter, können jedoch nicht
                        ausschließen, dass diese Daten beim Vorliegen von
                        rechtswidrigem Verhalten von Behörden eingesehen werden.
                    </p>
                    <p className='mb-6'>
                        Kurz gesagt: Ihr Besuch wird durch unseren Provider
                        (Firma, die unsere Website auf speziellen Computern
                        (Servern) laufen lässt), protokolliert, aber wir geben
                        Ihre Daten nicht ohne Zustimmung weiter!
                    </p>
                </section>
                <section>
                    <h2 className='text-2xl mb-4 mt-8 font-bold'>
                        Rechtsgrundlage
                    </h2>
                    <p className='mb-6'>
                        Die Rechtmäßigkeit der Verarbeitung personenbezogener
                        Daten im Rahmen des Webhosting ergibt sich aus Art. 6
                        Abs. 1 lit. f DSGVO (Wahrung der berechtigten
                        Interessen), denn die Nutzung von professionellem
                        Hosting bei einem Provider ist notwendig, um das
                        Unternehmen im Internet sicher und nutzerfreundlich
                        präsentieren und Angriffe und Forderungen hieraus
                        gegebenenfalls verfolgen zu können.
                    </p>
                    <p className='mb-6'>
                        Zwischen uns und dem Hosting-Provider besteht in der
                        Regel ein Vertrag über die Auftragsverarbeitung gemäß
                        Art. 28 f. DSGVO, der die Einhaltung von Datenschutz
                        gewährleistet und Datensicherheit garantiert.
                    </p>
                </section>
                <section>
                    <h2 className='text-2xl mb-4 mt-8 font-bold'>
                        1&1 IONOS Webhosting Datenschutzerklärung
                    </h2>
                    <p className='mb-6'>
                        Wir nutzen IONOS by 1&1 um unsere Website zu hosten. In
                        Deutschland hat die 1&1 IONOS SE ihren Sitz in
                        Elgendorfer Str. 57, 56410 Montabaur, in Österreich
                        finden Sie die 1&1 IONOS SE in der Gumpendorfer Straße
                        142/PF 266, 1060 Wien. IONOS bietet folgende Leistungen
                        rund um Webhosting an: Domain, Website & Shop, Hosting &
                        WordPress, Marketing, E-Mail & Office, IONOS Cloud und
                        Server.
                    </p>
                    <p className='mb-6'>
                        Wie im Abschnitt “Automatische Datenspeicherung”
                        erläutert, speichern Webserver, wie die von IONOS, Daten
                        jedes Websitebesuchs ab.
                    </p>
                    <p className='mb-6'>
                        Wenn Sie mehr über den Datenschutz für IONOS Website
                        erfahren möchten, besuchen Sie bitte die
                        Datenschutzerklärung auf ionos.de.
                    </p>
                </section>
                <section>
                    <h2 className='text-2xl mb-4 mt-8 font-bold'>
                        Auftragsverarbeitungsvertrag (AVV) IONOS
                    </h2>
                    <p className='mb-6'>
                        Wir haben im Sinne des Artikels 28 der
                        Datenschutz-Grundverordnung (DSGVO) mit IONOS einen
                        Auftragsverarbeitungsvertrag (AVV) abgeschlossen. Was
                        ein AVV genau ist und vor allem was in einem AVV
                        enthalten sein muss, können Sie in unserem allgemeinen
                        Abschnitt „Auftragsverarbeitungsvertrag (AVV)“
                        nachlesen.
                    </p>
                    <p className='mb-6'>
                        Dieser Vertrag ist gesetzlich vorgeschrieben, weil IONOS
                        in unserem Auftrag personenbezogene Daten verarbeitet.
                        Darin wird geklärt, dass IONOS Daten, die sie von uns
                        erhalten, nur nach unserer Weisung verarbeiten darf und
                        die DSGVO einhalten muss. Den Link zum
                        Auftragsverarbeitungsvertrag (AVV) finden Sie unter
                        https://www.ionos.de/hilfe/datenschutz/allgemeine-informationen-zur-datenschutz-grundverordnung-dsgvo/auftragsverarbeitung/.
                    </p>
                    <p className='mb-6'>
                        Alle Texte sind urheberrechtlich geschützt.
                    </p>
                    <p className='mb-6'>
                        Quelle: Erstellt mit dem Datenschutz Generator von
                        AdSimple
                    </p>
                </section>
            </article>
        </div>
    );
};
export default Datenschutz;
